import { toast } from "react-toastify";

const handleApiError = (error) => {
  // 1. حاول تجيب رسالة الخطأ من الباك
  const message = error?.response?.data?.message;

  // 2. لو الرسالة عبارة عن array (مثلاً validation errors)
  if (Array.isArray(message)) {
    message.forEach((msg) => console.log(msg));
    return;
  }

  // 3. لو الرسالة نص واحد (string)
  if (typeof message === "string") {
    // toast.error(message);
    return;
  }

  // 4. لو مفيش response (مثلاً المشكلة في الإنترنت أو السيرفر وقع)
  if (!error.response) {
    // toast.error("لا يوجد اتصال بالسيرفر. تأكد من الإنترنت.");
    return;
  }

  // 5. fallback عام لأي حالة غير متوقعة
  // toast.error("حدث خطأ غير متوقع. حاول مرة أخرى.");
};

export default handleApiError;
